import { render } from "./iconCurvaInscripcion.vue?vue&type=template&id=dbfb44b8&scoped=true"
import script from "./iconCurvaInscripcion.vue?vue&type=script&lang=js"
export * from "./iconCurvaInscripcion.vue?vue&type=script&lang=js"

import "./iconCurvaInscripcion.vue?vue&type=style&index=0&id=dbfb44b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dbfb44b8"

export default script